import { Box, ButtonBase, styled } from '@mui/material';
import { FC, ReactElement } from 'react';

type TThirdPartyLoginProps = {
    label: string;
    icon: ReactElement;
    onClick: () => void;
    type?: 'circle' | 'rectangle';
};

const SocialButtonCircle = styled(ButtonBase)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '100%',
    width: '64px',
    height: '64px',
    cursor: 'pointer',
}));

const SocialButton = styled(ButtonBase)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '8px',
    cursor: 'pointer',
    padding: '14px 17px',
    position: 'relative',
    display: 'block',
    width: '100%',
}));

const ThirdPartyLogin: FC<TThirdPartyLoginProps> = (props) => {
    const { label, icon, onClick, type = 'circle' } = props;
    if (type === 'circle') {
        return (
            <SocialButtonCircle aria-label={label} onClick={onClick}>
                {icon}
            </SocialButtonCircle>
        );
    } else {
        return (
            <SocialButton onClick={onClick}>
                <Box sx={{ position: 'absolute', left: '17px' }}>{icon}</Box>
                <Box sx={{ typography: 'subtitle2' }}>{label}</Box>
            </SocialButton>
        );
    }
};

export default ThirdPartyLogin;
